class Announcement extends HTMLElement {
    private lastScrollTop: number;
    private headerEle: Element | null | undefined;

    constructor() {
        super();
        this.lastScrollTop = 0;
        this.headerEle = document.querySelector('.section-header');
        this.bindEvents();
    }

    bindEvents() {
        this.announcementToggle();
        window.addEventListener('scroll', this.announcementToggle.bind(this));
    }

    announcementToggle(event?: Event) {
        const countrySelector = this.querySelector(".country-selector");
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop <= 0) {
            this.classList.remove("hide");
            this.headerEle?.classList.add("with-announcement-bar");
        }
        else if (scrollTop > this.lastScrollTop) {
            // Scroll down - hide the announcement bar
            this.classList.add("hide");
            this.headerEle?.classList.remove("with-announcement-bar");
            countrySelector?.setAttribute("hidden", "true");
        } 
        else {
            this.classList.remove("hide");
            this.headerEle?.classList.add("with-announcement-bar");
        }

        if (scrollTop <= 0) {
            this.headerEle?.classList.remove("sticky-header");
            this.headerEle?.querySelector(".header")?.classList.remove("shadow-elevation-4");
        }
        else {
            this.headerEle?.classList.add("sticky-header")
            this.headerEle?.querySelector(".header")?.classList.add("shadow-elevation-4");
        }

        this.lastScrollTop = scrollTop;
    }
}

customElements.define("header-announcement", Announcement);